"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="MailAccountData.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxMailAccountData object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxMailAccountData = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxMailAccountData = /** @class */ (function (_super) {
    __extends(HxMailAccountData, _super);
    function HxMailAccountData(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxMailAccountData, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxMailAccountData.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '6B':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '676':
                        var aliasesValues = v;
                        this.aliases = new Array(aliasesValues.length);
                        for (var i = 0; i < aliasesValues.length; i++) {
                            this.aliases[i] = aliasesValues[i];
                        }
                        break;
                    case 'EE1':
                        this.allMipLabelsId = new HxObjectID_1.default(v);
                        break;
                    case '127C':
                        this.canCreateHierarchy = v;
                        break;
                    case '677':
                        this.defaultAlias = v;
                        break;
                    case 'EB7':
                        this.defaultMipLabelId = new HxObjectID_1.default(v);
                        break;
                    case '64':
                        this.deletedItemsViewId = new HxObjectID_1.default(v);
                        break;
                    case '61':
                        this.doneViewId = new HxObjectID_1.default(v);
                        break;
                    case '62':
                        this.draftsViewId = new HxObjectID_1.default(v);
                        break;
                    case 'EA1':
                        this.groupViewsId = new HxObjectID_1.default(v);
                        break;
                    case '7F9':
                        this.hasReconciledWithUnistore = v;
                        break;
                    case '697':
                        this.inbox_OtherViewId = new HxObjectID_1.default(v);
                        break;
                    case '60':
                        this.inboxViewId = new HxObjectID_1.default(v);
                        break;
                    case '65':
                        this.junkMailViewId = new HxObjectID_1.default(v);
                        break;
                    case '5C0':
                        this.messagesId = new HxObjectID_1.default(v);
                        break;
                    case '142E':
                        this.mipLabelsAreMandatory = v;
                        break;
                    case 'DFC':
                        this.mipLabelsLastUpdated = new Date(v);
                        break;
                    case 'DFD':
                        this.mipLabelsStatusCode = v;
                        break;
                    case '1317':
                        this.mipLabelsTellMeMoreUrl = v;
                        break;
                    case '312':
                        this.outboxViewId = new HxObjectID_1.default(v);
                        break;
                    case '664':
                        this.preselectedMoveToViews_PrimaryId = new HxObjectID_1.default(v);
                        break;
                    case '665':
                        this.preselectedMoveToViews_SecondaryId = new HxObjectID_1.default(v);
                        break;
                    case '1506':
                        var proxyAddressesValues = v;
                        this.proxyAddresses = new Array(proxyAddressesValues.length);
                        for (var i = 0; i < proxyAddressesValues.length; i++) {
                            this.proxyAddresses[i] = proxyAddressesValues[i];
                        }
                        break;
                    case '119A':
                        this.recentlyUsedViewsId = new HxObjectID_1.default(v);
                        break;
                    case '648':
                        this.rmsStatusCode = v;
                        break;
                    case '647':
                        this.rmsTemplateLastUpdated = new Date(v);
                        break;
                    case '649':
                        this.rmsTemplatesId = new HxObjectID_1.default(v);
                        break;
                    case 'EE2':
                        this.rootUserMipLabelsId = new HxObjectID_1.default(v);
                        break;
                    case '96F':
                        this.rulesId = new HxObjectID_1.default(v);
                        break;
                    case 'C2D':
                        this.scheduledViewId = new HxObjectID_1.default(v);
                        break;
                    case '64A':
                        this.selfCertificateValidationCacheLastUpdated = new Date(v);
                        break;
                    case '63':
                        this.sentItemsViewId = new HxObjectID_1.default(v);
                        break;
                    case '145D':
                        this.sortViewsAlphabetically = v;
                        break;
                    case '1445':
                        this.supportedReactionTypesId = new HxObjectID_1.default(v);
                        break;
                    case 'B40':
                        this.syncingViewsId = new HxObjectID_1.default(v);
                        break;
                    case '5E':
                        this.syncState = v;
                        break;
                    case '41A':
                        this.syncViewsPending = v;
                        break;
                    case '1194':
                        this.topLevelViewsId = new HxObjectID_1.default(v);
                        break;
                    case '4DD':
                        this.topViewsId = new HxObjectID_1.default(v);
                        break;
                    case '5F':
                        this.viewsId = new HxObjectID_1.default(v);
                        break;
                    case 'DB5':
                        this.viewsWithoutInboxAndOutboxId = new HxObjectID_1.default(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxMailAccountData.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getAllMipLabels = function (sessionId) {
        return this.activeSet.getCollection(this.allMipLabelsId, sessionId);
    };
    HxMailAccountData.prototype.getDefaultMipLabel = function (sessionId) {
        return this.activeSet.getObject(this.defaultMipLabelId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getDeletedItemsView = function (sessionId) {
        return this.activeSet.getObject(this.deletedItemsViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getDoneView = function (sessionId) {
        return this.activeSet.getObject(this.doneViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getDraftsView = function (sessionId) {
        return this.activeSet.getObject(this.draftsViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getGroupViews = function (sessionId) {
        return this.activeSet.getCollection(this.groupViewsId, sessionId);
    };
    HxMailAccountData.prototype.getInbox_OtherView = function (sessionId) {
        return this.activeSet.getObject(this.inbox_OtherViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getInboxView = function (sessionId) {
        return this.activeSet.getObject(this.inboxViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getJunkMailView = function (sessionId) {
        return this.activeSet.getObject(this.junkMailViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getMessages = function (sessionId) {
        return this.activeSet.getCollection(this.messagesId, sessionId);
    };
    HxMailAccountData.prototype.getOutboxView = function (sessionId) {
        return this.activeSet.getObject(this.outboxViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getPreselectedMoveToViews_Primary = function (sessionId) {
        return this.activeSet.getObject(this.preselectedMoveToViews_PrimaryId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getPreselectedMoveToViews_Secondary = function (sessionId) {
        return this.activeSet.getObject(this.preselectedMoveToViews_SecondaryId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getRecentlyUsedViews = function (sessionId) {
        return this.activeSet.getCollection(this.recentlyUsedViewsId, sessionId);
    };
    HxMailAccountData.prototype.getRmsTemplates = function (sessionId) {
        return this.activeSet.getCollection(this.rmsTemplatesId, sessionId);
    };
    HxMailAccountData.prototype.getRootUserMipLabels = function (sessionId) {
        return this.activeSet.getCollection(this.rootUserMipLabelsId, sessionId);
    };
    HxMailAccountData.prototype.getRules = function (sessionId) {
        return this.activeSet.getCollection(this.rulesId, sessionId);
    };
    HxMailAccountData.prototype.getScheduledView = function (sessionId) {
        return this.activeSet.getObject(this.scheduledViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getSentItemsView = function (sessionId) {
        return this.activeSet.getObject(this.sentItemsViewId, sessionId).then(function (result) { return result; });
    };
    HxMailAccountData.prototype.getSupportedReactionTypes = function (sessionId) {
        return this.activeSet.getCollection(this.supportedReactionTypesId, sessionId);
    };
    HxMailAccountData.prototype.getSyncingViews = function (sessionId) {
        return this.activeSet.getCollection(this.syncingViewsId, sessionId);
    };
    HxMailAccountData.prototype.getTopLevelViews = function (sessionId) {
        return this.activeSet.getCollection(this.topLevelViewsId, sessionId);
    };
    HxMailAccountData.prototype.getTopViews = function (sessionId) {
        return this.activeSet.getCollection(this.topViewsId, sessionId);
    };
    HxMailAccountData.prototype.getViews = function (sessionId) {
        return this.activeSet.getCollection(this.viewsId, sessionId);
    };
    HxMailAccountData.prototype.getViewsWithoutInboxAndOutbox = function (sessionId) {
        return this.activeSet.getCollection(this.viewsWithoutInboxAndOutboxId, sessionId);
    };
    return HxMailAccountData;
}(HxObject_1.default));
exports.HxMailAccountData = HxMailAccountData;
exports.default = HxMailAccountData;
